module.exports = ".add-to-discover{\n    background: url(https://d2zmbkdpl0cf9q.cloudfront.net/../../../assets/icons/new/ADD_TO_DISCOVERIES_WHITE.svg) center center no-repeat;\n    \n}\n\n.remove-discover{\n    background: url(https://d2zmbkdpl0cf9q.cloudfront.net/../../../assets/icons/new/ADD_TO_DISCOVERIES_BLACK.svg) center center no-repeat;\n    \n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/add-to-discovery/add-to-discovery.component.css
// module id = ./src/app/shared/add-to-discovery/add-to-discovery.component.css
// module chunks = main